import { useEffect } from 'react'
import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import useTemplateId from './useTemplateId'
import { config } from 'lib/config'
import { store } from 'lib/store'
import { AppInstance } from 'types/apps'

export function useAppInstances(options?: SWRConfiguration) {
	const { withTemplateId } = useTemplateId()

	const { data, mutate, isLoading, error } = useSWR<AppInstance[]>(
		withTemplateId(`${config.apiURL}/v1.0/apps/instances`),
		options,
	)

	useEffect(() => {
		if (error) {
			store.dispatch({
				type: 'toast/set',
				payload: { kind: 'error', timeout: 6000, message: 'Something went wrong' },
			})
		}
	}, [error])

	return {
		appInstances: data,
		mutateAppInstance: mutate,
		areAppInstancesLoading: isLoading,
	}
}
